
import { Vue, Component, Prop } from "vue-property-decorator";

// import UiButton from "@/components/button/ui-button.vue";
import UiButtonTest from "@/components/button/ui-buttontest.vue";
// Commented out subscription import
// import AddSubscription from "@/views/manage//Modal/add-subcription-modal-resource.vue";
import ContractorInvite from "@/components/contractors/ContractorInviteNew.vue";
import PlusIcon from "@/components/icons/PlusIconNew.vue";
// Commented out subscription plan import
// import { SubscriptionPlan } from "@/entities/payment/SubscriptionPlan";
// import { Subscription } from "@/generated/graphql";
// import getActiveManagersCountCondition from "@/helpers/queryConditions/getActiveManagersCountCondition";
import HoveredIcon from "@/components/icons/HoveredIcon.vue";
// Commented out subscription details query
// import GET_SUBSCRIPTIONS_DETAILS from "@/apollo/payment/GetSubscriptionsDetails.gql";

// Commented out subscription details interface
/*
interface SubscriptionDetails {
  subscriptionPlans: SubscriptionPlan[];
  currentSubscription: Subscription;
  activeManagersCount: number;
  paymentCardId?: string;
}
*/

@Component({
  components: {
    UiButtonTest,
    ContractorInvite,
    // Commented out AddSubscription component
    // AddSubscription,
    PlusIcon,
    HoveredIcon,
  },
  // Commented out apollo query for subscription details
  /*
  apollo: {
    subscriptionDetails: {
      query: GET_SUBSCRIPTIONS_DETAILS,
      variables() {
        return {
          companyId: this.companyId,
          userId: this.currentUserId,
          activeManagersCountCondition: getActiveManagersCountCondition(
            this.companyId
          ),
        };
      },
      update: (data): SubscriptionDetails => {
        return {
          subscriptionPlans: data.subscription_plan,
          currentSubscription: data.subscription[0],
          activeManagersCount: data.activeManagersCount.aggregate.count,
          paymentCardId: data.payment_card[0]?.id,
        };
      },
    },
  },
  */
})
export default class InvitationSideBarNew extends Vue {
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly companyBusinessName!: string;
  @Prop({ type: String, default: undefined }) readonly size?: string;
  @Prop({ type: String, default: "Invite Resources" })
  readonly actionButtonContent!: string;
  @Prop({ type: Boolean, default: false }) readonly isManager!: boolean;

  contractorDialog: boolean = false;
  // Commented out subscription-related properties
  // subscriptionDetails: SubscriptionDetails | null = null;
  // showSubscriptionDialog: boolean = false;

  // Commented out subscription-related getters
  /*
  get currentSubscription(): Subscription {
    return this.subscriptionDetails.currentSubscription;
  }

  get freeTrialExpiry(): boolean {
    if (this.subscriptionDetails.currentSubscription) {
      const periodEndTime =
        this.subscriptionDetails.currentSubscription.current_period_end;
      const formattedEndDate = new Date(periodEndTime * 1000);

      const startDate = new Date(
        this.subscriptionDetails.currentSubscription.created_at
      );

      // Format dates into localized date strings
      const dateFormatter = new Intl.DateTimeFormat("en-US", {
        month: "long", // Full month name (e.g., "April")
        day: "numeric", // Day of the month (e.g., "21")
        year: "numeric", // Full year (e.g., "2022")
      });

      // Format the date using the dateFormatter
      const formattedEndDateStr = dateFormatter.format(formattedEndDate);
      const formattedStartDateStr = dateFormatter.format(startDate);

      const differenceMs = formattedEndDate.getTime() - startDate.getTime();

      const differenceDays = differenceMs / (1000 * 60 * 60 * 24);
      return Math.floor(differenceDays) > 7;
    }
  }
  */

  handleInviteClick() {
    // Simplified invite click handler - removed all subscription logic
    this.contractorDialog = true;

    // Commented out subscription-related logic
    /*
    if (this.currentSubscription.status === "active" || this.currentSubscription.status === "canceled" || this.isManager) {
      this.contractorDialog = true;
    } if (
      this.currentSubscription.status === "trialing" &&
      this.freeTrialExpiry
    ) {
      this.showSubscriptionDialog = !this.showSubscriptionDialog;
    }
    if (
      this.currentSubscription.status === "trialing" &&
      !this.freeTrialExpiry
    ) {
      this.contractorDialog = true;
    }
    */
  }

  get noCompany(): boolean {
    return !this.companyId;
  }
}
